<div class="main-holder">
  <vmb-header></vmb-header>
  <div class="content">
    <router-outlet/>
  </div>
  <vmb-footer></vmb-footer>
</div>
